import { makeStyles } from "@material-ui/core/styles"

import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	"@keyframes migrationModalPulse": {
		"0%": { boxShadow: `0 0 0 0 ${colors.purple[300]}99` },
		"70%": { boxShadow: `0 0 0 8px ${colors.purple[300]}00` },
		"100%": { boxShadow: `0 0 0 0 ${colors.purple[300]}00` }
	},
	dialogPaper: {
		borderRadius: 12,
		maxWidth: 600
	},
	closeIcon: {
		position: "absolute",
		top: 12,
		right: 8
	},
	title: {
		fontWeight: 700
	},
	subtitle: {
		color: colors.gray[500]
	},
	benefitIconBox: {
		backgroundColor: colors.gray[100],
		borderRadius: 8,
		width: 40,
		height: 40,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	benefitTitle: {
		fontWeight: 700
	},
	comparisonCard: {
		backgroundColor: colors.gray[50],
		border: `1px solid ${colors.gray[200]}`,
		borderRadius: 8,
		padding: theme.spacing(2)
	},
	comparisonLabel: {
		color: colors.gray[400],
		textTransform: "uppercase",
		fontWeight: 700,
		letterSpacing: "0.08em"
	},
	comparisonItemLabel: {
		fontWeight: 600,
		color: colors.gray[700]
	},
	videoIframe: {
		border: "none",
		borderRadius: 8,
		display: "block"
	},
	successIconWrapper: {
		width: 64,
		height: 64,
		borderRadius: "50%",
		backgroundColor: colors.green[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	formField: {
		marginBottom: theme.spacing(2)
	},
	actionButton: {
		height: 40,
		padding: "0px 8px",
		fontSize: 14
	},
	pulseButton: {
		animation: "$migrationModalPulse 2s infinite",
		"&:hover": {
			animation: "none"
		}
	},
	objectiveLabel: {
		fontWeight: 600,
		color: colors.gray[700],
		marginBottom: theme.spacing(0.5)
	}
}))

export default useStyles
